export default __webpack_public_path__ + "locales/fi/Ldap.json?hash=096cb86bbca7700abcaf62f4ea2d3e2b";